import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Container component for toolbar building blocks.
 * Uses ng-content with selectors for flexible composition.
 *
 * @example
 * ```html
 * <app-partner-toolbar>
 *   <ng-container toolbarLeft>
 *     <app-toolbar-title [title]="'My Title'" />
 *   </ng-container>
 *   <ng-container toolbarRight>
 *     <app-toolbar-search [(value)]="search" />
 *     <app-toolbar-export-button (exportClick)="onExport()" />
 *   </ng-container>
 * </app-partner-toolbar>
 * ```
 */
@Component({
  selector: 'app-partner-toolbar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="toolbar-container mb-2 flex flex-col gap-2 px-2 sm:mb-4 sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-4"
    >
      <div class="toolbar-left flex items-center gap-2 sm:gap-4">
        <ng-content select="[toolbarLeft]"></ng-content>
      </div>
      <div class="toolbar-right flex flex-wrap items-center gap-1 sm:flex-nowrap sm:gap-2">
        <ng-content select="[toolbarRight]"></ng-content>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerToolbarComponent {}
